"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var useI18n_1 = __importDefault(require("@paprika/l10n/lib/useI18n"));
var popover_1 = __importDefault(require("@paprika/popover"));
var constants_1 = require("../../constants");
var sc = __importStar(require("./Logo.styles"));
function Logo(_a) {
    var launchpadUrl = _a.launchpadUrl, zIndex = _a.zIndex;
    var i18n = useI18n_1.default();
    return (react_1.default.createElement(sc.LogoWrapper, { "data-sri-anchor": "navigation-logo" },
        react_1.default.createElement(popover_1.default, { isEager: true, isDark: true, zIndex: zIndex },
            react_1.default.createElement(popover_1.default.Trigger, null, function (handler) { return (react_1.default.createElement(sc.LogoAnchorTrigger, { "data-sri-anchor": "navigation-item.trigger", onMouseOver: handler, onMouseOut: handler, onBlur: handler, "aria-label": i18n.t('global_navigation.navigation_items.logo'), href: launchpadUrl, target: "_top" },
                react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 639 548" },
                    react_1.default.createElement("path", { fill: "#F0A117", fillRule: "evenodd", d: "M456.396,365.44 L638.97,0.317 L456.417,0.317 L298.212,316.7 L298.213,316.687 C292.286,328.291 281.386,331.669 273.701,331.669 C266.569,331.669 256.407,328.196 250.599,318.936 L182.553,182.876 L0,182.876 L91.292,365.44 L91.297,365.44 L0,548 L182.553,548 L249.482,414.176 L249.481,414.192 C255.407,402.585 266.307,399.21 273.992,399.21 C281.124,399.21 291.287,402.681 297.094,411.943 L365.14,548 L547.695,548 L456.401,365.44 L456.396,365.44" })))); }),
            react_1.default.createElement(popover_1.default.Content, null,
                react_1.default.createElement(popover_1.default.Card, null, i18n.t('global_navigation.navigation_items.logo'))),
            react_1.default.createElement(popover_1.default.Tip, null))));
}
Logo.propTypes = {
    launchpadUrl: prop_types_1.default.string.isRequired,
    zIndex: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
};
Logo.defaultProps = {
    zIndex: 9999,
};
Logo.componentType = constants_1.navigationItems.logo;
exports.default = Logo;
//# sourceMappingURL=Logo.js.map